export default "__VITE_ASSET__92d1e75c__"